exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_wks-ext.js
// module id = 72
// module chunks = 1